import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GroupDto, IProductDto } from './productlibrary.dto';
import { environment } from 'environments/environment';
import { IPageableResponse } from 'app/global/pagging.dto';
@Injectable({
  providedIn: 'root'
})
export class ProductlibraryService {

  constructor(private http: HttpClient) { }

  fetchGroups(){
    return this.http.get<GroupDto[]>('productlibrarygroups');
  }

  addGroup(form){
    return this.http.post<GroupDto>('productlibrarygroups',form);
  }

  fetchProducts(page: number | string, query: string){
    return this.http.get<IPageableResponse<IProductDto>>(`productlibraries?page=${page}&q=${query}`);
  }

  addProduct(form){
    return this.http.post<IProductDto>('productlibraries',form);
  }

  updateProduct(id, form){
    return this.http.post<IProductDto>(`productlibraries/${id}`,form);
  }


  deleteProduct(id: number){
    return this.http.delete(`productlibraries/${id}`);
  }

  getProductImage(path: string, id:number): string {
    return `${environment.apiUrl}productlibraries/${id}/stream-file?path=${path}`;
  }

  bulkUpload(form){
    return this.http.post(`productlibraries/upload-csv`,form);
  }
}

